<template>
	<div v-if="visible">
		<transition name="modal" class="scrollable">
			<div class="modal-mask-custom">
				<div :style="{'background-color': backgroundColor}" class="modal-container-custom">
					<div class="row p-0 m-0">
						<div class="col-12 p-0 m-0">
							<div class="modal-header-custom">
								<span @click="$emit('close')" class="modal-default-button-custom p-0 px-2 pt-1">
									<i class="fas fa-times fa-lg close-modal-btn"></i>
								</span>
								<slot name="header">&nbsp;</slot>
							</div>
						</div>
					</div>
					<div class="row p-0 m-0">
						<div class="col-12 p-0 m-0">
							<div class="modal-body-custom px-2 py-1">
								<slot name="body">&nbsp;</slot>
							</div>
						</div>
					</div>
					<div class="row p-0 m-0">
						<div class="col-12 p-0 m-0">
							<div class="modal-footer-custom">
								<slot name="footer">&nbsp;</slot>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		props: ["visible", "backgroundColor"]
	}
</script>

<style scoped>
	.close-modal-btn {
		color: white;
		cursor: pointer;
		transition: all 200ms ease;
		margin: auto;
	}

	.close-modal-btn:hover {
		font-size: 1.2em;
		color: #071537;
	}

	.modal-mask-custom {
		overflow:scroll;
		position: fixed;
		z-index: 9998;
		top:0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.7);
		transition: opacity 0.3s ease;
		display: flex;
		overflow-y: auto;
	}

	.modal-container-custom {
		position: relative;
		width: 90% !important;
		margin: 0px auto;
		padding: 0px;
		background-color: #fff;
		border-radius: 5px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
		--overflow: auto;
	}

	.modal-body-custom {
		margin: 0px;
	}

	.modal-default-button-custom {
		float: right;
		color: #fff;
	}

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container-custom,
	.modal-leave-active .modal-container-custom {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.modal-container-custom {
			width: 98% !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.modal-container-custom {
			width: 80% !important;
			/*height: 80% !important;*/
			margin: auto auto;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.modal-container-custom {
			width: 80% !important;
			/*height: 80% !important;*/
			margin: auto auto;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.modal-container-custom {
			width: 80% !important;
			/*height: 80% !important;*/
			margin: auto auto;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.modal-container-custom {
			width: 60% !important;
			/*height: 80% !important;*/
			margin: auto auto;
		}
	}
</style>